import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImportedInvoiceDetailRowsWrapper = styled.div`
  padding: 0 ${Spacing.S24};
`
